module.exports = __webpack_public_path__ + "img/xzlqhb_biaoti.398e2452.png";